module.exports = __webpack_public_path__ + "static/media/icon-photo.9af40d3c.svg";